@use "../../styles/breakpoint.module.scss" as *;

.content {
    padding: var(--spacer-48);

    @media ($above-mobile) and ($below-tablet) {
        padding-block: 0;
    }

    @media ($below-mobile) {
        padding-bottom: var(--spacer-8);
    }
}

.carousel {
    position: relative;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
            180deg,
            rgb(var(--true-black-base) / 0%) 66%,
            rgb(var(--true-black-base) / 100%) 100%
        );
    }

    @media ($below-mobile) {
        & .content {
            --padding: var(--spacer-80);
        }
    }
}

.carousel,
.carouselWrapper,
.carouselInner,
.carouselTabPanel {
    height: 100%;
}

.carouselTabList {
    --color-contrast: var(--white);

    position: absolute;
    bottom: var(--spacer-24);
    width: 100%;
    justify-content: center;
    translate: 0;
    z-index: 1;
    gap: 0;
}

.carouselTab {
    position: relative;
    width: 16px;
    height: 16px;
    background-color: transparent;

    &::before {
        content: "";
        position: absolute;
        inset: 4px;
        background-color: var(--color-contrast);
        border-radius: 4px;
    }

    &:not([aria-selected]) {
        opacity: 1;

        &::before {
            inset: 5px;
            opacity: 0.7;
        }
    }
}

.carouselTabPanel {
    vertical-align: top;
}

.carouselNav {
    --color-contrast: var(--white);
    --margin: calc(var(--labui-container-margin));

    position: absolute;
    inset: auto var(--margin) var(--spacer-48);
    display: flex;
    justify-content: space-between;

    @media ($below-mobile) {
        display: none;
    }
}

.navArrow {
    width: var(--spacer-40);
    height: var(--spacer-40);
}
